import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-754c222a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forbidden-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "code-error" }, "404", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "msg-error" }, "Oops! Página não encontrada!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "info-error" }, " A página que você está procurando não existe ou está em manutenção. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "info-error" }, " Você pode voltar à página anterior ou ir para a nossa página inicial ", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Voltar para a página anterior ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_BackPageButton = _resolveComponent("BackPageButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createVNode(_component_BackPageButton, {
      class: "box-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseIcon, {
          class: "icon-button",
          name: "back",
          size: "15px"
        }),
        _hoisted_6
      ]),
      _: 1
    })
  ]))
}